module.exports = __webpack_public_path__ + "img/79e6a6d2005d5bf37f6a14e9f7547310.svg";